import BaseDropSelection from "%/dynamic-component-editor/classes/base-drop-selection";
import { declarationsForApp } from "%/dynamic-component-editor/options/declared-app-options";
import { QUIZZES_POLLS_APP_NAME } from "+/QuizzesPolls/app-name";

export const QUESTIONNAIRE_ELEMENT_TYPE = "QuestionnaireElement";
export const OPTION_STATE_ELEMENT_TYPE = "OptionStateElement";
export const CHECKBOX_STATE_ELEMENT_TYPE = "CheckboxStateElement";
export const REQUIRED_GATE_ELEMENT_TYPE = "RequiredAnswersGate";
export const QUESTIONNAIRE_CARDS_OPTION_KEY = "questionnaire-cards";
export const OPTION_STATES_OPTION_KEY = "option-states";
export const CHECKBOX_STATES_OPTION_KEY = "checkbox-states";
export const REQUIRED_GATE_STATES_OPTION_KEY = "required-gate-states";

const ROW_PLACEHOLDER = "Select a component";

function rowsForGroup(cardGroup) {
  return Object.entries(declarationsForApp(QUIZZES_POLLS_APP_NAME))
      .filter(([, declaration]) => declaration.componentReference
        && declaration.toolProps?.cardGroup === cardGroup)
      .map(([optionKey, declaration]) => ({
        optionKey,
        rowLabel: declaration.label ?? optionKey,
        placeholder: ROW_PLACEHOLDER,
        optional: true,
      }));
}

class AppCardSelection extends BaseDropSelection {
  static createItemLabel = "Create a new component";
  static defaultNewItemName = "New Component";
  static createPlaceholder = "Name your new component";
  static pickExistingLabel = "Choose an existing component instead";

  static candidates(store) {
    return store.referencedComponentCandidates
        .map(candidate => ({ label: candidate.name, value: candidate.id }));
  }

  static createCandidate(store, name) {
    return store.createComponentForDropSelection(name);
  }
}

export class QuestionnaireCardSelection extends AppCardSelection {
  static optionKey = QUESTIONNAIRE_CARDS_OPTION_KEY;
  static modalTitle = "Select questionnaire cards";
  static promptText = "Pick the component that renders each kind of answer input, and the one "
    + "that renders the submission itself. An input type with no component bound to it is left "
    + "out of the questionnaire.";

  static rows() {
    return rowsForGroup(QUESTIONNAIRE_CARDS_OPTION_KEY);
  }
}

export class OptionStateSelection extends AppCardSelection {
  static optionKey = OPTION_STATES_OPTION_KEY;
  static modalTitle = "Select option state components";
  static promptText = "Pick the component that renders an option the reader has chosen, and the "
    + "one that renders an option they have not. A state with no component bound to it renders "
    + "nothing, so an option in that state is invisible.";

  static rows() {
    return rowsForGroup(OPTION_STATES_OPTION_KEY);
  }
}

export class CheckboxStateSelection extends AppCardSelection {
  static optionKey = CHECKBOX_STATES_OPTION_KEY;
  static modalTitle = "Select checkbox state components";
  static promptText = "Pick the component that renders a ticked checkbox, and the one that "
    + "renders an unticked one. A state with no component bound to it renders nothing, so a "
    + "checkbox in that state is invisible.";

  static rows() {
    return rowsForGroup(CHECKBOX_STATES_OPTION_KEY);
  }
}

export class RequiredGateSelection extends AppCardSelection {
  static optionKey = REQUIRED_GATE_STATES_OPTION_KEY;
  static modalTitle = "Select submit gate components";
  static promptText = "Pick the component that renders a submission ready to be sent, and the "
    + "one that renders it while required questions are still unanswered. A state with no "
    + "component bound to it renders nothing, so a submission in that state shows neither.";

  static rows() {
    return rowsForGroup(REQUIRED_GATE_STATES_OPTION_KEY);
  }
}

if (QuestionnaireCardSelection.rows().length) {
  BaseDropSelection.register(QUESTIONNAIRE_ELEMENT_TYPE, QuestionnaireCardSelection);
}
if (OptionStateSelection.rows().length) {
  BaseDropSelection.register(OPTION_STATE_ELEMENT_TYPE, OptionStateSelection);
}
if (CheckboxStateSelection.rows().length) {
  BaseDropSelection.register(CHECKBOX_STATE_ELEMENT_TYPE, CheckboxStateSelection);
}
if (RequiredGateSelection.rows().length) {
  BaseDropSelection.register(REQUIRED_GATE_ELEMENT_TYPE, RequiredGateSelection);
}

export default QuestionnaireCardSelection;
